import { Component, OnInit, Output, EventEmitter, TemplateRef, ViewChild } from "@angular/core";
import { NgbOffcanvas } from "@ng-bootstrap/ng-bootstrap";
import { RootReducerState } from "src/app/store";
import { Store } from "@ngrx/store";
import {
  getBackgroundImage,
  getLayoutMode,
  getLayoutPosition,
  getLayoutTheme,
  getLayoutWith,
  getPreloader,
  getSidebarColor,
  getSidebarImage,
  getSidebarSize,
  getSidebarView,
  getSidebarVisibilitye,
  getTheme,
  getThemeColor,
  getTopbarColor
} from "src/app/store/layouts/layout-selector";
import {
  changeBackgrounImage,
  changeDataPreloader,
  changeLayoutPosition,
  changeLayoutWidth,
  changeMode,
  changeSidebarColor,
  changeSidebarImage,
  changeSidebarSize,
  changeSidebarView,
  changeSidebarVisibility,
  changeTheme,
  changeThemeColor,
  changeTopbar,
  changelayout
} from "src/app/store/layouts/layout-action";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-rightsidebar",
  templateUrl: "./rightsidebar.component.html",
  styleUrls: ["./rightsidebar.component.scss"],
  standalone: false
})

/**
 * Right Sidebar component
 */
export class RightsidebarComponent implements OnInit {
  layout: string | undefined;
  theme: string | undefined;
  themecolor: string | undefined;
  mode: string | undefined;
  width: string | undefined;
  position: string | undefined;
  topbar: string | undefined;
  size: string | undefined;
  sidebarView: string | undefined;
  sidebar: string | undefined;
  attribute: any;
  sidebarImage: any;
  sidebarVisibility: any;
  preLoader: any;
  grd: any;
  backgroundImage: any;

  @ViewChild("filtetcontent") filtetcontent!: TemplateRef<any>;
  @Output() settingsButtonClicked = new EventEmitter();

  constructor(private offcanvasService: NgbOffcanvas, private store: Store<RootReducerState>, private helper: Helper) {}

  ngOnInit(): void {
    this.store.select("layout").subscribe((data) => {
      this.layout = data.LAYOUT;
      this.theme = data.LAYOUT_THEME;
      this.themecolor = data.LAYOUT_THEME_COLOR;
      this.mode = data.LAYOUT_MODE;
      this.width = data.LAYOUT_WIDTH;
      this.position = data.LAYOUT_POSITION;
      this.topbar = data.TOPBAR;
      this.size = data.SIDEBAR_SIZE;
      this.sidebarView = data.SIDEBAR_VIEW;
      this.sidebar = data.SIDEBAR_COLOR;
      this.sidebarImage = data.SIDEBAR_IMAGE;
      this.preLoader = data.DATA_PRELOADER;
      this.sidebarVisibility = data.SIDEBAR_VISIBILITY;
    });
  }

  /**
   * Change the layout onclick
   * @param layout Change the layout
   */
  changeLayout(layout: string): void {
    this.attribute = layout;
    this.store.dispatch(changelayout({ layout }));
    this.store.select(getLayoutTheme).subscribe((layouts) => {
      document.documentElement.setAttribute("data-layout", layouts);
    });
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 100);
  }

  // Add Active Class
  addActive(grdSidebar: any): void {
    this.grd = grdSidebar;
    document.documentElement.setAttribute("data-sidebar", grdSidebar);
    document.getElementById("collapseBgGradient")?.classList.toggle("show");
    document.getElementById("collapseBgGradient1")?.classList.add("active");
  }

  // Remove Active Class
  removeActive(): void {
    this.grd = "";
    document.getElementById("collapseBgGradient1")?.classList.remove("active");
    document.getElementById("collapseBgGradient")?.classList.remove("show");
  }

  // When the user clicks on the button, scroll to the top of the document
  topFunction(): void {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  //  Filter Offcanvas Set
  openEnd(content: TemplateRef<any>): void {
    this.offcanvasService.open(content, { position: "end" });

    setTimeout(() => {
      this.attribute = document.documentElement.getAttribute("data-layout");
      if (this.attribute === "vertical") {
        const vertical = document.getElementById("customizer-layout01") as HTMLInputElement;
        if (vertical !== null) {
          vertical.setAttribute("checked", "true");
        }
      }
      if (this.attribute === "horizontal") {
        const horizontal = document.getElementById("customizer-layout02");
        if (horizontal !== null) {
          horizontal.setAttribute("checked", "true");
        }
      }
      if (this.attribute === "twocolumn") {
        const Twocolumn = document.getElementById("customizer-layout03");
        if (Twocolumn !== null) {
          Twocolumn.setAttribute("checked", "true");
        }
      }
      if (this.attribute === "semibox") {
        const Twocolumn = document.getElementById("customizer-layout04");
        if (Twocolumn !== null) {
          Twocolumn.setAttribute("checked", "true");
        }
      }
    }, 100);
  }

  // Show Profile Sidebar
  showSidebarProgile(event: any): void {
    if (event.target.checked) {
      document.documentElement.setAttribute("data-sidebar-user-show", "");
    } else {
      document.documentElement.removeAttribute("data-sidebar-user-show");
    }
  }

  // Theme Change
  changelayoutTheme(theme: string): void {
    this.theme = theme;
    this.store.dispatch(changeTheme({ theme }));
    this.store.select(getTheme).subscribe((themes) => {
      document.documentElement.setAttribute("data-theme", themes);
    });

    if (theme === "saas") {
      const layout = "horizontal";
      this.store.dispatch(changelayout({ layout }));
    } else if (theme === "creative") {
      const layout = "twocolumn";
      this.store.dispatch(changelayout({ layout }));
    } else {
      const layout = "vertical";
      this.store.dispatch(changelayout({ layout }));
    }

    if (theme === "galaxy") {
      this.store.dispatch(changeMode({ mode: "dark" }));
      this.helper.themeMode.next({});
    } else {
      this.store.dispatch(changeMode({ mode: "light" }));
      this.helper.themeMode.next({});
    }

    if (theme === "modern") {
      this.store.dispatch(changeSidebarSize({ sidebarSize: "sm-hover" }));
    } else {
      this.store.dispatch(changeSidebarSize({ sidebarSize: "lg" }));
    }

    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 100);
  }

  // Change Theme Color
  changeColor(themecolor: string): void {
    this.themecolor = themecolor;
    this.store.dispatch(changeThemeColor({ themecolor }));
    this.store.select(getThemeColor).subscribe((themecolors) => {
      document.documentElement.setAttribute("data-theme-colors", themecolors);
    });
  }

  // Mode Change
  changeLayoutMode(mode: string): void {
    this.mode = mode;
    this.store.dispatch(changeMode({ mode }));
    this.helper.themeMode.next({});

    this.store.select(getLayoutMode).subscribe((modes) => {
      document.documentElement.setAttribute("data-bs-theme", modes);
    });
    // document.documentElement.setAttribute('data-bs-theme', mode)
  }

  // Visibility Change
  changeVisibility(sidebarvisibility: string): void {
    this.sidebarVisibility = sidebarvisibility;
    this.store.dispatch(changeSidebarVisibility({ sidebarvisibility }));
    this.store.select(getSidebarVisibilitye).subscribe((visibility) => {
      document.documentElement.setAttribute("data-sidebar-visibility", visibility);
    });
  }

  // Width Change
  changeWidth(layoutWidth: string, size: string): void {
    this.width = layoutWidth;
    this.store.dispatch(changeLayoutWidth({ layoutWidth }));
    this.store.select(getLayoutWith).subscribe((width) => {
      document.documentElement.setAttribute("data-layout-width", width);
      document.documentElement.setAttribute("data-sidebar-size", size);
    });

    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 100);
  }

  // Position Change
  changePosition(layoutPosition: string): void {
    this.position = layoutPosition;
    this.store.dispatch(changeLayoutPosition({ layoutPosition }));
    this.store.select(getLayoutPosition).subscribe((position) => {
      document.documentElement.setAttribute("data-layout-position", position);
    });
  }

  // Topbar Change
  changeTopColor(topbarColor: string): void {
    this.topbar = topbarColor;
    this.store.dispatch(changeTopbar({ topbarColor }));
    this.store.select(getTopbarColor).subscribe((color) => {
      document.documentElement.setAttribute("data-topbar", color);
    });
  }

  // Sidebar Size Change
  changeSidebarSize(sidebarSize: string): void {
    this.size = sidebarSize;
    this.store.dispatch(changeSidebarSize({ sidebarSize }));
    this.store.select(getSidebarSize).subscribe((size) => {
      document.documentElement.setAttribute("data-sidebar-size", size);
    });
  }

  // Sidebar Size Change
  changeSidebar(sidebarView: string): void {
    this.sidebarView = sidebarView;
    this.store.dispatch(changeSidebarView({ sidebarView }));
    this.store.select(getSidebarView).subscribe((view) => {
      document.documentElement.setAttribute("data-layout-style", view);
    });
  }

  // Sidebar Color Change
  changeSidebarColor(sidebarColor: string): void {
    this.sidebar = sidebarColor;
    this.store.dispatch(changeSidebarColor({ sidebarColor }));
    this.store.select(getSidebarColor).subscribe((color) => {
      document.documentElement.setAttribute("data-sidebar", color);
    });
  }

  // Sidebar Image Change
  changeSidebarImage(sidebarImage: string): void {
    this.sidebarImage = sidebarImage;
    this.store.dispatch(changeSidebarImage({ sidebarImage }));
    this.store.select(getSidebarImage).subscribe((image) => {
      document.documentElement.setAttribute("data-sidebar-image", image);
    });
  }

  // Sidebar Image Change
  changeBackgroundImage(backgroundImage: string): void {
    this.backgroundImage = backgroundImage;
    this.store.dispatch(changeBackgrounImage({ backgroundImage }));
    this.store.select(getBackgroundImage).subscribe((image) => {
      document.documentElement.setAttribute("data-body-image", image);
    });
  }

  // PreLoader Image Change
  changeLoader(Preloader: string): void {
    this.preLoader = Preloader;
    this.store.dispatch(changeDataPreloader({ Preloader }));
    this.store.select(getPreloader).subscribe((loader) => {
      document.documentElement.setAttribute("data-preloader", loader);
    });

    const preloader = document.getElementById("preloader");
    if (preloader) {
      setTimeout(function () {
        (document.getElementById("preloader") as HTMLElement).style.opacity = "0";
        (document.getElementById("preloader") as HTMLElement).style.visibility = "hidden";
      }, 1000);
    }
  }
}
